"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoldBenefitShillaDfsParticipateResponseSchema = exports.GoldBenefitShillaDfsParticipateInputSchema = exports.GoldBenefitShillaDfsAvailableResponseSchema = exports.GoldBenefitShillaDfsAvailableInputSchema = exports.GOLD_BENEFIT_SHILLA_DFS_FAIL_CODE = void 0;
var zod_1 = require("zod");
exports.GOLD_BENEFIT_SHILLA_DFS_FAIL_CODE = {
    /** 골드 클래스  */
    NOT_GOLD_CLASS: 'NOT_GOLD_CLASS',
    /** 이미 프로모션에 참여 */
    ALREADY_PARTICIPATED: 'ALREADY_PARTICIPATED',
    /** 재고 부족 */
    NOT_ENOUGH_STOCK: 'NOT_ENOUGH_STOCK',
    /** 프로모션 기간이 아님 */
    NOT_PROMOTION_PERIOD: 'NOT_PROMOTION_PERIOD',
    /** 관리자에 의해 정지된 프로모션 */
    STOPPED_PROMOTION: 'STOPPED_PROMOTION',
};
/**
 * 신라면세점 프로모션 API - 1. 참여가능 여부 조회
 *
 * @see https://yanolja.atlassian.net/wiki/x/v4Y2F
 */
exports.GoldBenefitShillaDfsAvailableInputSchema = zod_1.z.object({
    requestAt: zod_1.z.string().optional(),
});
exports.GoldBenefitShillaDfsAvailableResponseSchema = zod_1.z.object({
    available: zod_1.z.boolean(),
    failureReason: zod_1.z
        .enum([
        exports.GOLD_BENEFIT_SHILLA_DFS_FAIL_CODE.NOT_GOLD_CLASS,
        exports.GOLD_BENEFIT_SHILLA_DFS_FAIL_CODE.ALREADY_PARTICIPATED,
        exports.GOLD_BENEFIT_SHILLA_DFS_FAIL_CODE.NOT_ENOUGH_STOCK,
        exports.GOLD_BENEFIT_SHILLA_DFS_FAIL_CODE.NOT_PROMOTION_PERIOD,
        exports.GOLD_BENEFIT_SHILLA_DFS_FAIL_CODE.STOPPED_PROMOTION,
    ])
        .nullable(),
    couponCode: zod_1.z.string().nullable(),
});
/**
 * 신라면세점 프로모션 API - 2. 응모하기
 *
 * @see https://yanolja.atlassian.net/wiki/x/4APkEw
 */
exports.GoldBenefitShillaDfsParticipateInputSchema = zod_1.z.object({
    requestAt: zod_1.z.string().optional(),
});
exports.GoldBenefitShillaDfsParticipateResponseSchema = zod_1.z.object({
    couponCode: zod_1.z.string(),
});
